(function( $, doc ) {
    "use strict";

    (function(){

        // ACTION minimize
        $(".wpmudev-can--hide").ready(function(){

            var $this = $(this),
                $button = $this.find(".wpmudev-box-header .wpmudev-box--action");

            $button.on("click", function(){

                var $parent = $(this).closest(".wpmudev-can--hide");

                $parent.toggleClass("wpmudev-is--hidden");

            });

        });

        // NEW QUIZ
        // ACTION open/close answer info
        $(".wpmudev-wizard--answer").ready(function(){

            var $this = $(this),
                $button = $this.find(".wpmudev-answer--header .wpmudev-button-action");

            $button.on("click", function(){

                var $parent = $(this).closest(".wpmudev-wizard--answer");

                $parent.toggleClass("wpmudev-is_closed");

            });

        });

    }());
    
}( jQuery, document ));